{
  "shared": {
    "email": "Email",
    "changePassword": "Change Password"
  },
  "areaGrants": {
    "title": "Zone access for {{zone}}",
    "levels": {
      "none": "None",
      "dataOnly": "Data only",
      "pageAndData": "Page + data"
    },
    "explainer": "<bold>Page + data</bold> opens the screen and everything on it. <bold>Data only</bold> grants the numbers behind it for reporting on them elsewhere, without putting it in the menu or opening a URL. Saved when you apply, and it reaches anyone signed in straight away. A user sees what all their zones grant together, so removing a page here takes it away only from users no other zone of theirs grants it to.",
    "notForContractor": "(not allowed for a contractor zone)",
    "noDataReader": "Nothing reads this one at data level, so it would grant no more than None.",
    "apply": "Apply"
  },
  "zoneAccess": {
    "pages_one": "{{count}} page",
    "pages_other": "{{count}} pages",
    "pagesAndData_one": "{{count}} page<muted>, {{data}} data only</muted>",
    "pagesAndData_other": "{{count}} pages<muted>, {{data}} data only</muted>"
  },
  "dashboardTiles": {
    "blurb": "Controls which quick-access tiles and dashboard cards appear on the Home dashboard for each zone. This only hides or shows the shortcut/card - it does not change which pages a zone can access. A quick tile still requires that the zone already has access to its destination page; this can only hide something it would otherwise see.",
    "quickTiles": "Quick Tiles",
    "quickTilesField": "Quick Tiles (leave blank to hide the whole row)",
    "dashboardCards": "Dashboard Cards",
    "saved": "Dashboard tiles updated for {{zone}}"
  },
  "sectionNames": {
    "blurb": "Renames a top-level nav section for this deployment (e.g. \"Geology\" to \"Grade Control\"). The English name is used in every language without a name of its own, and a blank English name keeps the default. Suggest asks Claude for the other languages from the English name; check them before you save. This only changes the label shown in the menu - it does not affect page access.",
    "section": "Section",
    "suggest": "Suggest",
    "suggested": "Check the suggested names, then save.",
    "saved": "Section name updated"
  },
  "users": {
    "role": "Role",
    "zones": "Zones",
    "notifications": "Notifications",
    "receiveNotificationsFrom": "Receive Notifications from",
    "statusActive": "Active",
    "statusDisabled": "Disabled",
    "enable": "Enable",
    "disable": "Disable",
    "rolesLoadFailed": "Error while fetching the user roles.",
    "disabled": "User disabled",
    "enabled": "User enabled",
    "deleted": "User deleted successfully",
    "nameRequired": "User name is required",
    "validEmailRequired": "Valid email is required",
    "emailRequired": "Email is required",
    "invalidEmail": "Invalid email format",
    "updated": "User updated successfully",
    "added": "User added successfully",
    "passwordChanged": "Password changed successfully",
    "cannotDisableSelf": "You cannot disable your own account.",
    "resetNeedsLeadAdmin": "Only a Lead Admin can reset the password of a user who belongs to more than one zone.",
    "language": "Language"
  },
  "zones": {
    "zoneName": "Zone Name",
    "zoneColour": "Zone Colour",
    "subcontractor": "Subcontractor",
    "pageAccess": "Page Access",
    "editZone": "Edit Zone",
    "accessUnavailable": "Unavailable",
    "accessSaved": "Zone access updated for {{zone}}",
    "nameRequired": "Zone Name is required",
    "colourRequired": "Zone Colour is required",
    "colourInvalid": "Zone Colour is invalid",
    "saved": "Zone updated successfully",
    "deleted": "Zone deleted successfully",
    "confirmDelete": "Are you sure you want to delete this Zone? This action cannot be undone."
  },
  "account": {
    "details": "Details",
    "changeName": "Change",
    "notificationSettings": "Notification Settings",
    "pushNotifications": "Enable Push Notifications",
    "emailNotifications": "Enable Email Notifications",
    "manageApiKeys": "Manage API Keys",
    "language": "Default language",
    "nameEmpty": "Name cannot be empty",
    "saved": "User updated successfully",
    "passwordUpdated": "Password updated sucessfully"
  },
  "apiKeys": {
    "intro": "API keys allow Power BI, Excel Power Query, and other tools to access reporting endpoints without needing to log in. Each key is shown only once; store it safely.",
    "createdNotice": "Key created; copy it now, it won't be shown again.",
    "copy": "Copy to clipboard",
    "createTitle": "Create new key",
    "labelField": "Label (e.g. Power BI – Site Report)",
    "validFor": "Valid for (days)",
    "create": "Create",
    "label": "Label",
    "created": "Created",
    "expires": "Expires",
    "lastUsed": "Last used",
    "none": "No API keys yet.",
    "neverUsed": "Never",
    "statusActive": "Active",
    "statusExpired": "Expired",
    "statusRevoked": "Revoked",
    "revoke": "Revoke key",
    "loadFailed": "Failed to load API keys.",
    "labelRequired": "Please enter a label for the key.",
    "revokeFailed": "Failed to revoke key.",
    "revoked": "Key revoked.",
    "copied": "Copied to clipboard."
  },
  "login": {
    "logoAlt": "Logo",
    "title": "Sign In",
    "or": "or",
    "password": "Password",
    "submit": "Login",
    "enterCredentials": "Please enter your email and password.",
    "success": "Login successful.",
    "goToSignup": "Go to the demo sign-up",
    "noAccountYet": "Don't have an account yet? <signupLink>Sign up for the demo</signupLink>",
    "continueWithMicrosoft": "Continue with Microsoft",
    "continueWithLinkedIn": "Continue with LinkedIn",
    "microsoftFailed": "Microsoft sign-in was cancelled or failed.",
    "googleNoToken": "Google sign-in did not return a token.",
    "googleFailed": "Google sign-in failed.",
    "providerUnavailable": "Sign-in with {{provider}} is not available here. Please use one of the options below.",
    "linkedInCancelled": "LinkedIn sign-in was cancelled."
  },
  "notFound": {
    "title": "Page not found",
    "body": "Unfortunately, the page you are looking for does not exist."
  }
}
